import { Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface AcceptCheckboxProps {
  accepted: boolean;
  onToggle: () => void;
  label: string;
  sublabel?: string;
  linkLabel?: string;
  linkUrl?: string;
  onLinkClick?: () => void;
}

export function AcceptCheckbox({
  accepted,
  onToggle,
  label,
  sublabel,
  linkLabel,
  linkUrl,
  onLinkClick,
}: AcceptCheckboxProps) {
  const { t } = useTranslation('booking');
  return (
    <div className="space-y-2">
      <div>
        <p className="font-medium text-sm text-foreground">{label}</p>
        {sublabel && <p className="text-sm text-foreground/50">{sublabel}</p>}
        {linkLabel && (onLinkClick || linkUrl) && (
          <button
            type="button"
            className="text-brand text-sm"
            onClick={onLinkClick || (() => window.open(linkUrl, '_blank'))}
          >
            {linkLabel}
          </button>
        )}
      </div>
      <div className="flex justify-end">
        <button
          type="button"
          aria-pressed={accepted}
          aria-label={t('STRING_ACCEPT')}
          // Fixed h + min-w lock dimensions across the unaccepted/accepted
          // states so the icon swap doesn't reflow the layout. min-w is sized
          // for German "AKZEPTIEREN", the longest locale variant.
          className={`h-9 min-w-[92px] px-3.5 rounded-md text-xs font-semibold tracking-wider transition-colors flex items-center justify-center ${
            accepted
              ? 'bg-brand text-brand-foreground'
              : 'bg-foreground/5 text-foreground/70 hover:bg-foreground/10'
          }`}
          onClick={onToggle}
        >
          {accepted ? <Check className="h-4 w-4" aria-hidden="true" /> : t('STRING_ACCEPT')}
        </button>
      </div>
    </div>
  );
}
